module.exports = __webpack_public_path__ + "static/media/DSC_0013.9e930c1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0013.jpg
// module id = 585
// module chunks = 0